import { api } from '../lib/api'

export type AdminDisputeListItem = {
  job_id: number
  post_id: number
  title: string
  job_mode: string
  job_kind: string
  job_visibility: string
  escrow_status: string
  escrow_amount_pixe: number | string
  funded_at?: string | null
  auto_release_at?: string | null
  status: string
  dispute_opened_at?: string | null
  dispute_resolved_at?: string | null
  dispute_resolution?: string | null
  dispute_split_bps_to_pro?: number | null
  client: { user_id: number; handle?: string; display_name?: string } | null
  pro: { user_id: number; handle?: string; display_name?: string } | null
  pending_deliveries_count?: number
}

export type AdminDisputeListResponse = {
  count: number
  limit: number
  offset: number
  results: AdminDisputeListItem[]
}

export type AdminDisputeDetailResponse = {
  job: AdminDisputeListItem & {
    summary?: string
    details_md?: string
    location_mode?: string
    location_text?: string
    client_location_text?: string
    client_zipcode?: string
  }
  evidence: Array<{
    id: number
    submitted_by: { user_id: number; handle?: string; display_name?: string } | null
    message: string
    attachments?: string[]
    created_at?: string | null
  }>
  escrow_events: Array<{
    id: number
    event_type: string
    actor: { user_id: number; handle?: string; display_name?: string } | null
    note?: string
    amount_pixe?: number | string | null
    fee_pixe?: number | string | null
    net_pixe?: number | string | null
    created_at?: string | null
  }>
  suggestions: {
    fee_bps: number
    total_pixe: number | string
    max_refund_pixe: number | string
    max_pro_gross_pixe: number | string
  }
}

export async function listDisputes(params: {
  status?: 'open' | 'resolved' | 'all'
  q?: string
  limit?: number
  offset?: number
}) {
  const { data } = await api.get<AdminDisputeListResponse>('/api/admin/jobs/disputes/', { params })
  return data
}

export async function getDisputeDetail(jobId: number | string) {
  const { data } = await api.get<AdminDisputeDetailResponse>(`/api/admin/jobs/${jobId}/dispute/detail/`)
  return data
}

export async function resolveDispute(
  jobId: number | string,
  payload: { resolution: 'RELEASE_TO_PRO' | 'REFUND_TO_CLIENT' | 'SPLIT'; split_bps_to_pro?: number; admin_note?: string },
) {
  const { data } = await api.post(`/api/admin/jobs/${jobId}/escrow/dispute/resolve/`, payload)
  return data as {
    ok: boolean
    status: string
    resolution: string
    dispute_resolution?: string
    dispute_split_bps_to_pro?: number | null
    total_pixe: number
    fee_pixe: number
    pro_net_pixe: number
    client_refund_pixe: number
    escrow_status: string
    dispute_resolved_at?: string | null
  }
}
